export default __webpack_public_path__ + "static/media/CL36_SE.9dc1d388.jpg";